import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import "../StyleComponent/HomeComponents.css";
import ContentICICI from "./ContentICICI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faCircleLeft } from "@fortawesome/free-solid-svg-icons";
import { faCircleRight } from "@fortawesome/free-solid-svg-icons";
import scroll_down from "../Assets/scroll_down.png";
import scroll_up from "../Assets/top.png";

// Import images
import bankQRImage from "../Assets/BankQR.png";
import posImage from "../Assets/POS.png";
import soundboxImage from "../Assets/Soundbox.png";
// import logoImage from "../Assets/logo.png";
import paymentImage from "../Assets/payment.png";
import videoFile from "../Assets/video.mp4";

import b from "../Assets/circul.jpg";
import p from "../Assets/circul1.jpg";
import pp from "../Assets/circul2.jpg";
import s from "../Assets/circul4.jpg";

// Mapping solution names to images
const solutionImages = {
  "UPI QR": b,
  POS: pp,
  "Payment Gateway and Links": p,
  SoundBox: s,
};

function App() {
  const handleScrollDown = () => {
    if (window.scrollY === 0) {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedSolution, setSelectedSolution] = useState("UPI QR");
  const [isScrolled, setIsScrolled] = useState(false);

  const scrollContainerRef = useRef(null);
  const contentICICIRef = useRef(null); // Create a ref for ContentICICI

  const [isLeftArrowClicked, setIsLeftArrowClicked] = useState(true);
  const [isRightArrowClicked, setIsRightArrowClicked] = useState(false);

  const [solutionTransactions, setSolutionTransactions] = useState([
    { name: "UPI QR", image: bankQRImage },
    { name: "POS", image: posImage },
    { name: "SoundBox", image: soundboxImage },
    { name: "Payment Gateway and Links", image: paymentImage },
  ]);

  const touchStart = useRef(null);
  const touchEnd = useRef(null);

  const minSwipeDistance = 50;

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= window.screen.height / 2) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [window]);

  // const onTouchStart = (e) => {
  //   touchEnd.current = null;
  //   touchStart.current = e.targetTouches[0].clientX;
  // };

  // const onTouchMove = (e) => {
  //   touchEnd.current = e.targetTouches[0].clientX;
  // };

  // const onTouchEnd = () => {
  //   if (!touchStart.current || !touchEnd.current) return;
  //   const distance = touchStart.current - touchEnd.current;
  //   const isLeftSwipe = distance > minSwipeDistance;
  //   const isRightSwipe = distance < -minSwipeDistance;
  //   if (isLeftSwipe || isRightSwipe) {
  //     if (isLeftSwipe) {
  //       scrollRight();
  //     } else {
  //       scrollLeft();
  //     }
  //   }
  // };

  // const handleClick = (solutionName) => {
  //   setSelectedSolution(solutionName);
  //   // No reordering of the solutionTransactions array
  //   setCurrentIndex(0); // Keep this if you still want to reset the scroll index
  // };

  // const handleDotClick = (index) => {
  //   const container = scrollContainerRef.current;
  //   const containerWidth = container.clientWidth;

  //   setCurrentIndex(index);
  //   container.scrollTo({
  //     left: containerWidth * index,
  //     behavior: "smooth",
  //   });
  // };
  useEffect(() => {
    handleResize();
  }, [currentIndex]);

  const handleResize = () => {
    const container = scrollContainerRef.current;
    const containerWidth = container.clientWidth;

    container.scrollTo({
      left: containerWidth * currentIndex,
      behavior: "smooth",
    });
  };

  const handleKnowMore = (solution) => {
    // Desired position based on the solution
    const desiredPosition = {
      "UPI QR": 0,
      POS: 1,
      SoundBox: 2,
      "Payment Gateway and Links": 3,
    };

    // Get the index of the solution to move
    const indexToMove = solutionTransactions.findIndex(
      (item) => item.name === solution.name
    );

    // Create a new array with the solution moved to the desired position
    const reorderedSolutions = solutionTransactions.filter(
      (_, index) => index !== indexToMove
    );
    reorderedSolutions.splice(desiredPosition[solution.name], 0, solution);

    // Update the state with reordered solutions
    setSolutionTransactions(reorderedSolutions);
    setSelectedSolution(solution.name);
    setCurrentIndex(desiredPosition[solution.name]);
  };

  useEffect(() => {
    setSelectedSolution(solutionTransactions[currentIndex].name);
  }, [currentIndex]);

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  const scrollLeft = () => {
    const newIndex = Math.max(0, currentIndex - 1);
    setCurrentIndex(newIndex);
  };

  const scrollRight = () => {
    const newIndex = Math.min(
      solutionTransactions.length - 1,
      currentIndex + 1
    );
    setCurrentIndex(newIndex);
  };

  // useEffect(() => {
  //   const container = scrollContainerRef.current;
  //   if (container) {
  //     container.scrollTo({
  //       left: container.clientWidth * currentIndex,
  //       behavior: "smooth",
  //     });
  //   }
  // }, [currentIndex]);

  // const scrollToIndex = (index) => {
  //   const container = scrollContainerRef.current;
  //   if (container) {
  //     container.scrollTo({
  //       left: container.clientWidth * index,
  //       behavior: "smooth",
  //     });
  //   }
  // };

  // const handleDotClick = (index) => {
  //   scrollToIndex(index);
  //   setCurrentIndex(index);
  // };
  const renderDetails = () => {
    switch (selectedSolution) {
      case "UPI QR":
        return (
          <div className='info-section'>
            <h2>Simplify your collections with ICICI Bank QR Code</h2>
            <ul>
              <li>100% digital onboarding</li>
              <li>Instant transaction alerts on multiple mobile numbers</li>
              <li>UPI dashboard to track all transactions in real-time</li>
              <li>
                Simplify collections through multiple counters with sub-merchant
                QR Codes
              </li>
            </ul>
          </div>
        );
      case "POS":
        return (
          <div className='info-section'>
            <h2>
              Hassle-free payment collection on the go through multiple payment
              modes.
            </h2>
            <ul>
              <li>Settlement available 365 days</li>
              <li>24x7 customer support</li>
              <li>Comprehensive merchant dashboard</li>
              <li>Voice notification for all transactions</li>
              <li>ERP integration available</li>
            </ul>
          </div>
        );
      case "SoundBox":
        return (
          <div className='info-section'>
            <h2>
              Receive real-time audio & visual transaction alerts for ICICI Bank
              QR collections.
            </h2>
            <ul>
              <li>Pay through any UPI app</li>
              <li>Bilingual sound notification</li>
              <li>4G SIM connectivity</li>
              <li>24x7 customer support</li>
            </ul>
          </div>
        );
      case "Payment Gateway and Links":
        return (
          <div className='info-section'>
            <h2>
              Collect payments remotely through various online and offline payment modes.
            </h2>
            <ul>
              {/* <li>Easiest & fastest way to collect payments</li> */}
              <li>50+ payment modes accepted</li>
              <li>Comprehensive merchant dashboard</li>
              <li>Developer-friendly easy integrations</li>
              <li>
                Daily MIS and customisable reports for quick reconciliation
              </li>
              <li>
                Upload a single file & share payment links with multiple payers
              </li>
              <li>
                Collect the customer information you want, with customisable fields
              </li>
            </ul>
          </div>
        );

      default:
        return null;
    }
  };

  const fixedImage = solutionImages[selectedSolution];
  const handleProceedClick = () => {
    if (contentICICIRef.current) {
      contentICICIRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <>
      <div className='header'>
        {/* <img src={logoImage} alt='ICICI Bank' className='logo' /> */}
      </div>

      <div className='video-container'>
        <ReactPlayer
          url={videoFile}
          playing
          muted
          loop
          controls={false}
          width='100%'
          height='auto'
          className='video'
        />
        <h2 className='video_h2'>
          Get Payment Collection Solutions best suited to <span>grow</span> your
          business
        </h2>
      </div>
      <img
        src={isScrolled ? scroll_up : scroll_down}
        alt='scroll up and down'
        onClick={handleScrollDown}
        className='scroll_down img-fluid'
      />
      <ContentICICI onKnowMore={handleKnowMore} ref={contentICICIRef} />
      <div className='container'>
        <div>
          <h2 className='hhh2'>
            Get payment collection solutions best suited to grow your business
          </h2>
        </div>
      </div>

      <div className='container'>
        <div
          className='payment-solutions1 payment-solutions11'
        // onTouchStart={onTouchStart}
        // onTouchMove={onTouchMove}
        // onTouchEnd={onTouchEnd}
        >
          <div className='solution-icons'>
            {/* <button
            className="arrow left-arrow"
            onClick={scrollLeft}
            style={{
              color: currentIndex === 0 ? "#d3d3d3" : "#8b0000",
              cursor: currentIndex === 0 ? "not-allowed" : "pointer",
            }}
            disabled={currentIndex === 0} 
          >
            &lt;
          </button> */}
            <FontAwesomeIcon
              icon={faCircleLeft}
              className='arrow left-arrow'
              onClick={scrollLeft}
              style={{
                color: currentIndex === 0 ? "#d3d3d3" : "#8b0000",
                cursor: currentIndex === 0 ? "not-allowed" : "pointer",
              }}
              disabled={currentIndex === 0}
            />

            <div className='icon-scroll-container' ref={scrollContainerRef}>
              {solutionTransactions.map((item, index) => (
                <div
                  key={index}
                  className={`solution-icon ${index === currentIndex ? "selected" : ""
                    }`}
                  onClick={() => setCurrentIndex(index)}
                >
                  <div className='icon-circle'>
                    <img src={item.image} alt={item.name} />
                    <div className='spa'>
                      <span style={{ color: "#8B0000" }}>{item.name}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <FontAwesomeIcon
              icon={faCircleRight}
              className='arrow right-arrow'
              onClick={scrollRight}
              style={{
                color:
                  currentIndex === solutionTransactions.length - 1
                    ? "#d3d3d3"
                    : "#8b0000",
                cursor:
                  currentIndex === solutionTransactions.length - 1
                    ? "not-allowed"
                    : "pointer",
              }}
              disabled={currentIndex === solutionTransactions.length - 1}
            />
            {/* <FontAwesomeIcon icon="fa-solid fa-circle-right" /> */}
          </div>

          <div className='scroll-wrapper'>{renderDetails()}</div>
          {/* <div className="image-section">
          <div className="circular-image">
            <img src={fixedImage} alt={selectedSolution} />
          </div>
        </div> */}
        </div>
      </div>
      <footer className='icici-footer2'>
        <p>
          *Terms and Conditions of ICICI Bank apply. For details{" "}
          <Link to='/ClickHere'>Click Here.</Link>
        </p>
        <p>
          Corporate Office Address: ICICI Bank Towers, Bandra-Kurla Complex,
          Mumbai 400 051
        </p>
      </footer>
      {/* <button onClick={handleProceedClick}  className='get-growing-btn1' >
          Proceed
        </button> */}
    </>
  );
}

export default App;
